import { useNavigate } from "react-router-dom";
import { FileText, Crown } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

interface NewArticleDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ARTICLE_OPTIONS = [
  {
    icon: FileText,
    title: "블로그 아티클",
    description: "외부 URL을 연결하는 블로그 아티클을 작성합니다.",
    path: "/articles/new",
  },
  {
    icon: Crown,
    title: "프리미엄 아티클",
    description: "작가 파일을 기반으로 프리미엄 아티클을 발행합니다.",
    path: "/articles/files",
  },
] as const;

export function NewArticleDialog({ open, onOpenChange }: NewArticleDialogProps) {
  const navigate = useNavigate();

  const handleSelect = (path: string) => {
    onOpenChange(false);
    navigate(path);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>새 아티클 유형 선택</DialogTitle>
          <DialogDescription>작성할 아티클 유형을 선택해주세요.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 pt-2">
          {ARTICLE_OPTIONS.map((option) => (
            <button
              key={option.path}
              type="button"
              onClick={() => handleSelect(option.path)}
              className="hover:bg-muted/50 flex items-start gap-4 rounded-lg border p-4 text-left transition-colors"
            >
              <option.icon className="text-muted-foreground mt-0.5 h-5 w-5 shrink-0" />
              <div>
                <p className="font-medium leading-none">{option.title}</p>
                <p className="text-muted-foreground mt-1.5 text-sm">{option.description}</p>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
